const Message = () => {
    return (
        <div>
            <p>This is Message page</p>
        </div>
    )
}

export default Message